import { useEffect, useState } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import { postApi } from "redux/apis";
import { toastText } from "utils/utils";
import BusinessSelector from "components/common/BusinessSelector";

interface Business {
  name: string;
  businessId: number;
  accountId: string;
}

interface ApiResponse {
  data: {
    data: {
      data?: Business[];
      message?: string;
    };
  };
}

const CallbackComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [queryParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [businesses, setBusinesses] = useState<Business[]>([]);

  const handleBusinessSelect = async (business: Business) => {
    try {
      const savedBusinessAPIEndpoint = "/fresh-books/update";
      setIsLoading(true);

      const data: any = {
        data: business,
        companyId: localStorage.getItem("companyId"),
        integration: localStorage.getItem("integration"),
      };
      const res = await postApi(savedBusinessAPIEndpoint, data);
      console.log("res", res.data);
      if (res?.data?.message) {
        localStorage.setItem(
          "freshbookCompany",
          JSON.stringify(res.data.data.companyName)
        );
        toastText(res?.data?.message, "success");
        navigate("/connectedapp");
      }
    } catch (error: any) {
      const errMessage = error?.response?.data?.message;
      toastText(errMessage, "error");
      navigate("/failtoconnect");
    } finally {
      setIsLoading(false);
    }
  };

  const handleApiCall = async (
    apiEndpoint: string,
    data: Record<string, any>
  ) => {
    try {
      const res: ApiResponse = await postApi(apiEndpoint, data);
      console.log('res: ', res);

      const responseData: any = res?.data?.data;
      console.log('responseData: ', responseData);

      // Store the response in localStorage
      localStorage.setItem("callbackResponse", JSON.stringify(responseData));

      if (location.pathname.startsWith("/freshbook/callback")) {
        setBusinesses(responseData);
        setIsModalOpen(true);
      } else {
        navigate("/connectedapp");
        const message = responseData?.message;
        toastText(message ?? "Connection successful", "success");
      }
    } catch (error: any) {
      const errMessage = error?.response?.data?.error?.message;
      toastText(errMessage, "error");
      navigate("/failtoconnect");
    }
  };

  useEffect(() => {
    const run = async () => {
      setIsLoading(true);

      try {
        if (location.pathname.startsWith("/freshbook/callback")) {
          await handleApiCall("/fresh-books/callback", {
            code: queryParams.get("code"),
            companyId: localStorage.getItem("companyId"),
          });
        } else if (location.pathname.startsWith("/qbo/callback")) {
          const url = window.location.href;
          await handleApiCall("/qbo/callback", {
            url,
            companyId: localStorage.getItem("t"),
          });
        } else if (location.pathname.startsWith("/zoho/callback")) {
          await handleApiCall("/zoho/callback", {
            code: queryParams.get("code"),
            companyId: localStorage.getItem("t"),
          });
        } else if (location.pathname.startsWith("/xero/callback")) {
          const currentURL = window.location.href;
          const origin = window.location.origin;
          const url = currentURL.replace(origin, "");
          await handleApiCall("/xero/callback", {
            url,
            companyId: localStorage.getItem("t"),
          });
        } else if (location.pathname.startsWith("/wave/callback")) {
          await handleApiCall("/wave/callback", {
            code: queryParams.get("code"),
            companyId: localStorage.getItem("t"),
          });
        }
      } catch (error) {
        console.error("Error in callback processing:", error);
      } finally {
        setIsLoading(false);
      }
    };

    run();
  }, [location.pathname, queryParams]);

  return (
    <div className={styles["main-container"]}>
      {isLoading && (
        <img
          src={`${process.env.REACT_APP_IMAGES_BASE_URL}/assets/gifs/loading.gif`}
          height={60}
          crossOrigin={
            process.env.REACT_APP_ENV === "local" ? undefined : "anonymous"
          }
        />
      )}

      <BusinessSelector
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleBusinessSelect}
        businesses={businesses}
      />
    </div>
  );
};

export default CallbackComponent;
